import { Component, inject, OnInit } from '@angular/core';
import { AnleitungService } from '../../service/anleitung/anleitung.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { UflaUser } from '../../service/auth/ufla-user';
import { OrganisationsTyp } from '../../domain/model/organisationsTyp';
import { Anleitungsdokument } from '../../domain/model/anleitung';
import { map } from 'rxjs/operators';
import { NeueAnleitung } from '../../domain/model/neueanleitung';
import { UpAndDownloadComponent } from '../../common/upload/up-and-download-component';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'ufla-anleitungen-list',
    templateUrl: './anleitungen-list.component.html',
    styleUrls: [
        './anleitungen-list.component.scss',
    ],
    standalone: false,
})
export class AnleitungenListComponent extends UpAndDownloadComponent implements OnInit {

    anleitungService = inject(AnleitungService);
    private route = inject(ActivatedRoute);

    public anleitungen$: Observable<Anleitungsdokument[]>;
    public uflaUser: UflaUser;
    public lastUploadedNeueAnleitung: NeueAnleitung;

    constructor() {
        const http = inject(HttpClient);

        super();
        this.http = http;

        this.uflaUser = this.route.snapshot.data.profile;
    }

    ngOnInit(): void {
        this.reLoadAnleitungen();
    }

    private reLoadAnleitungen() {
        this.anleitungen$ = this.anleitungService.listAllAnleitungen().pipe(
            map(anleitungen => {
                if (anleitungen.findIndex(anleitung => anleitung.organisationsTyp == OrganisationsTyp.UENB) == -1) {
                    anleitungen.push(this.anleitungService.createEmptyAnleitungsDokumentFor(OrganisationsTyp.UENB));
                }
                if (anleitungen.findIndex(anleitung => anleitung.organisationsTyp == OrganisationsTyp.VNB) == -1) {
                    anleitungen.push(this.anleitungService.createEmptyAnleitungsDokumentFor(OrganisationsTyp.VNB));
                }
                if (anleitungen.findIndex(anleitung => anleitung.organisationsTyp == OrganisationsTyp.NVNB_VOLLINTEGRIERT) == -1) {
                    anleitungen.push(this.anleitungService.createEmptyAnleitungsDokumentFor(OrganisationsTyp.NVNB_VOLLINTEGRIERT));
                }
                return anleitungen;
            }),
            map(anleitungen => anleitungen.sort((a, b) => a.organisationsTyp.localeCompare(b.organisationsTyp))));
        this.anleitungService.reloadAnleitungPresent();
    }

    deleteAnleitungByRole(organisationsTyp: OrganisationsTyp) {
        try {
            this.anleitungService.deleteAnleitungByRole(organisationsTyp).then(_ => this.reLoadAnleitungen());
        } catch (e) {
            console.error('Fail to delete Anleitung for role: ' + organisationsTyp, e);
        }
    }

    async uploadAnleitung(neueAnleitung: NeueAnleitung) {
        this.lastUploadedNeueAnleitung = neueAnleitung;
        await this.anleitungService.uploadAnleitung(neueAnleitung, this);
        this.reLoadAnleitungen();
    }
}
